import { render } from "./loading.vue?vue&type=template&id=9d5b9fea&scoped=true"
const script = {}

import "./loading.vue?vue&type=style&index=0&id=9d5b9fea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d5b9fea"]])

export default __exports__